import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'

import { TagResponse } from '@tabeeb/contracts/microservices/swagger-ai-service'
import { AIQueryKeys } from '../queries'

const useTags = () => {
  const { aiServiceApi: api } = useApi()

  const query = useQuery({
    queryKey: [AIQueryKeys.Tags],
    queryFn: api.tags.getAllAsync,
  })

  return {
    loading: query.isLoading,
    tags: (query.data ?? []) as TagResponse[],
  }
}

export default useTags
